import React, { Component } from "react";
import PaginatedDialogViewStyle from "./PaginatedDialogViewStyle";
import DialogHeaderView from "../DialogBase/components/DialogHeader/DialogHeaderView";
import PaginatedDialogViewProps from "./PaginatedDialogViewProps";

export default class PaginatedDialogView extends Component<PaginatedDialogViewProps> {

    private _style = new PaginatedDialogViewStyle();

    render() {
        const { children, ...rest } = this.props;
        return (
            <div style={this._style.paginatedDialog}>
                <DialogHeaderView {...rest}  />

                <div style={this._style.content}> 
                    {children}
                </div>
            </div>
        );
    }
}